module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/core-js/modules/_path.js
// module id = 604
// module chunks = 1